import React from 'react';

const AirportIcon = () => (
    <React.Fragment>
        <g>
            <path d="M22,16v-2l-8.5-5V3.5C13.5,2.67,12.83,2,12,2s-1.5,0.67-1.5,1.5V9L2,14v2l8.5-2.5V19L8,20.5L8,22l4-1l4,1l0-1.5L13.5,19 v-5.5L22,16z" />
            <path d="M0,0h24v24H0V0z" fill="none" />
        </g>
    </React.Fragment>
);

export default AirportIcon;
